import styled from 'styled-components';

import {
  mediaConfined,
  mediaSmallOnly,
  mediaConfinedOnly,
} from '@xingternal/layout-tokens';
import { FooterLoggedout } from '@xingternal/platform-layout-footer';
import { CenterContainer } from '@xingternal/platform-layout-view-wrapper';
import { xdlColorBackground } from '@xingternal/tokens';
import { GridContainer } from '@xingternal/xing-grid';

const StyledLoggedOutViewWrapper = styled.div`
  background-color: ${xdlColorBackground};
`;

const StyledSection = styled.section`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  /* This flex item doesn't seem to grow up to its parent's width without a given initial width */
  width: 0%;

  @media ${mediaSmallOnly} {
    width: 100%;
  }

  @media ${mediaConfined} {
    padding-bottom: 0;
  }

  /* 740px - 1112px */
  @media ${mediaConfinedOnly} {
    justify-content: center;
  }
`;

const StyledMain = styled.main`
  display: flex;
  justify-content: center;
`;

const StyledCenterContainer = styled(CenterContainer)`
  @media ${mediaConfined} {
    ${({ type }) => type === 'fullScreen' && `width: 100%;`}
  }
`;

const StyledContent = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 100%;

  @media ${mediaConfinedOnly} {
    max-width: 800px;
  }
`;

export const BlankWithFooterLayout: React.FC<{
  loginLink: string;
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <StyledLoggedOutViewWrapper>
      <main>{children}</main>
      <StyledCenterContainer type="standard">
        <StyledSection>
          <StyledContent>
            <StyledMain id="content">
              <GridContainer type="standard"></GridContainer>
            </StyledMain>
          </StyledContent>
        </StyledSection>
      </StyledCenterContainer>

      <FooterLoggedout homeLink="/" />
    </StyledLoggedOutViewWrapper>
  );
};
